import {Loader} from "./lib/loader";
import {find, findOne} from "@leap-spark/sparkies";
import * as bootstrap from "bootstrap";


Loader.on(null, () => {

    document.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
            const dropdown = findOne('#navbarDropdown') as HTMLElement;

            if (dropdown && dropdown.classList.contains('show')) {
                const drop = new bootstrap.Dropdown(dropdown);
                drop.hide();
            }
        }
    });

    // Close menu button in dropdown menus, located on the right side of the dropdown panel.
    findOne('#js-close-menu')?.addEventListener('click', function () {
        const el = findOne('#navbarDropdown');
        const drop = new bootstrap.Dropdown(el);
        drop.hide();
    });

    // Allow hover behavior for dropdowns
    {
        const allDropdowns = find('[data-bs-toggle="dropdown"]');

        if (!allDropdowns) {
            return;
        }

        allDropdowns.forEach((item: Element): void => {
            item.addEventListener('mouseover', function (e: Event): void {
                const a = new bootstrap.Dropdown(e.target as Element);
                a?.toggle();
            });
        });
    }

    // Dropdown Menu Initialization
    {
        // The dropdown menu, left side. Clicking one of these will display a new "box" menu on the right side.
        const els = find('[data-lp-toggle]');

        if (!els) {
            return;
        }

        const allMenus = find('.box-menu');
        const dropdownMenus = findOne('#js-dropdown-menus');

        // Really feel like there's got to be a better way of handling this.
        // This is removing the 'active' class from the Li > an elements in the dropdown menus (left side). And then re-adding
        // active class to the element that was clicked.
        dropdownMenus.addEventListener('click', function (e: Event): void {
            Array.from(dropdownMenus.children).forEach((i: Element): void => {
                i.querySelector('a').classList.remove('active');

                if (i === e.target) {
                    i.querySelector('a').classList.add('active');
                }
            })
        });

        const hide = (arr: Element[]): void => {
            arr.forEach((i: Element): void => i.classList.remove('active'));
        };

        els.forEach((el: Element): void => {
            el.addEventListener('click', function (): void {
                const d = this.dataset.lpToggle;
                const e = findOne(`#${d}`);
                hide(allMenus);
                e?.classList.add('active');
            });
        });
    }
});
